<template>
  <div>
    <div class="ExemptReview">
      <!-- banner -->
      <!-- <div class="bannerDiv">
        <img src="@/assets/images/policy/nav.png" alt="" class="banner" />
        <h2 class="bannerTitle">咨询建议</h2>
      </div> -->
      <!-- 内容 -->
      <div class="dis_box main-width m_t20">
        <div class="dis_box_left">
          <div class="top">我要咨询建议</div>
          <div class="form-title mt24">信息内容</div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="目的" prop="type">
              <el-radio-group v-model="ruleForm.type">
                <span
                  v-for="item in dicData"
                  :key="item.value"
                  style="margin-right: 20px"
                >
                  <el-radio :label="item.value">{{ item.name }}</el-radio>
                </span>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="标题" prop="title">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入不少于2个字的标题"
                v-model="ruleForm.title"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="描述" prop="content">
              <el-input
                type="textarea"
                :rows="5"
                placeholder="请输入不少于5个字的描述"
                v-model="ruleForm.content"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="上传附件" prop="fileList">
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :headers="headers"
                :before-upload="handelCheckFile"
                :before-remove="beforeRemove"
                multiple
                :limit="3"
                accept=".png,.jpg,.jpeg"
                :on-exceed="handleExceed"
                :on-success="handleSuccess"
                :on-error="handleError"
                :file-list="ruleForm.fileList"
                :on-remove="handleRemove"
              >
                <el-button type="button" class="el-icon-upload2">上传附件</el-button>
                <!--   zd 20230913 新增    -->
                <div slot="tip" class="el-upload__tip">只能上传jpg/png/jpeg文件，且不超过20M</div>
              </el-upload>
            </el-form-item>
            <div class="form-title mt24" style="margin-top: 40px">企业信息</div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="企业名称" prop="companyName">
                  <el-input
                    v-model="ruleForm.companyName"
                    placeholder="请输入企业名称"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="所在地区" prop="companyRegion">
                  <el-cascader
                    placeholder="所在地区"
                    :options="mapData"
                    v-model="ruleForm.companyRegion"
                    :props="{
                      checkStrictly: true,
                      label: 'name',
                      value: 'id',
                      emitPath: false,
                    }"
                    clearable
                  ></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="联系人" prop="conpanyContacts">
                  <el-input
                    v-model="ruleForm.conpanyContacts"
                    placeholder="请输入内容"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="conpanyContactsPhone">
                  <el-input
                    v-model="ruleForm.conpanyContactsPhone"
                    placeholder="请输入内容"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')"
                >立即提交</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="dis_box_right">
          <div class="dis_box_right_top">
            我的咨询建议
            <span
              class="more"
              v-if="tableData.length > 3"
              @click="
                $router.push({
                  path: '/unit/appeal',
                })
              "
              >更多>></span
            >
          </div>
          <div class="state-no-data">
            <div v-for="(item, index) in tableData" :key="item.id">
              <p v-if="index < 3">{{ item.title }}</p>
            </div>
          </div>
          <div class="process-box">
            <div class="process-title">办理流程</div>
            <div style="height: 300px; margin-left: 25px; margin-top: 46px">
              <el-steps direction="vertical" :active="6">
                <el-step
                  title="1.咨询建议"
                  description="选择目的，填写咨询建议"
                ></el-step>
                <el-step
                  title="2.主管部门跟进"
                  description="责任单位，协办单位共同处理"
                ></el-step>
                <el-step
                  title="3.处理进度查询"
                  description="登录网站查询咨询建议办理进度"
                ></el-step>
                <el-step
                  title="4.诉求办结反馈"
                  description="短信、电话、站内信等多渠道反馈处理结果"
                ></el-step>
                <!-- <el-step
                  title="5.企业评价服务"
                  description="多维度评价诉求服务"
                ></el-step> -->
              </el-steps>
            </div>
          </div>
        </div>
      </div>
      <!-- 切换 -->
      <!-- <div class="qa-box  main-width">
        <div class="qa-box_dis">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="全部问题" name="0">
              <WenTi></WenTi>
            </el-tab-pane>
            <el-tab-pane label="疫情防空" name="1">
              <YiQing></YiQing>
            </el-tab-pane>
            <el-tab-pane label="商事登记" name="2">
              <ShangShi></ShangShi>
            </el-tab-pane>
            <el-tab-pane label="年报" name="3">
              <NianBao></NianBao>
            </el-tab-pane>
            <el-tab-pane label="社保" name="4">
              <SheBao></SheBao>
            </el-tab-pane>
            <el-tab-pane label="防疫通" name="5">
              <FangYiTong></FangYiTong>
            </el-tab-pane>
            <el-tab-pane label="公积金" name="6">
              <Gongjijin></Gongjijin>
            </el-tab-pane>
            <el-tab-pane label="消防安全" name="7">
              <XiaoFang></XiaoFang>
            </el-tab-pane>
          </el-tabs>
          <div class="look">
            <p class="see-more">查看更多></p>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import WenTi from "@components/wenti.vue";
import YiQing from "@components/yiqing.vue";
import ShangShi from "@components/shangshi.vue";
import NianBao from "@components/nianbao.vue";
import SheBao from "@components/shebao.vue";
import FangYiTong from "@components/fangyitong.vue";
import Gongjijin from "@components/gongjijin.vue";
import XiaoFang from "@components/xiaofang.vue";
import { dicItem, allDistrict } from "@/api/common";
import { addAppeal, myAppealPageList } from "@/api/policy";
import { getStorage } from "@/common/utils";
import config from "@/config";
export default {
  components: {
    WenTi,
    YiQing,
    ShangShi,
    NianBao,
    SheBao,
    FangYiTong,
    Gongjijin,
    XiaoFang,
  },
  data() {
    return {
      uploadUrl: `${config.commonUrl}common/upload/fileTemplate`,
      mapData: [],
      tableData: [],
      ruleForm: {
        type: "",
        title: "",
        content: "",
        companyName: "",
        fileList: [],
        companyRegion: "",
        conpanyContacts: "",
        conpanyContactsPhone: "",
      },
      rules: {
        type: [{ required: true, message: "请选择目的", trigger: "change" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入描述", trigger: "blur" }],
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        // fileList: [
        //   { required: true, message: "请上传文件", trigger: "change" },
        // ],
        companyRegion: [
          { required: true, message: "请输入所在地区", trigger: "blur" },
        ],
        conpanyContacts: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        conpanyContactsPhone: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "blur",
          },
          {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
            message: "请输入正确的手机号/电话号",
          },
        ],
      },
      activeName: "0",
      activeNames: ["0"],
      fileList: [],
      dicData: [],
      headers: { accessToken: getStorage("token") },
      fileSize: '20M'
    };
  },
  mounted() {
    this.ruleForm.companyName = getStorage("basic").nickName;
    dicItem("hd_appeal_type").then((res) => {
      this.dicData = res.data.result;
    });
    allDistrict().then((res) => {
      res.data.result.shift();
      this.mapData = this.getTreeData(res.data.result);
    });
    const options = {
      pageNumber: this.current,
      pageSize: this.size,
    };
    if (getStorage("basic")) {
      myAppealPageList(options).then((res) => {
        const { code, result, msg } = res.data;
        if (code === 200 && result) {
          let { records } = result;
          this.tableData = records;
        }
      });
    } else {
      this.tableData = [
        {
          title: "请登录后查看",
        },
      ];
    }
  },
  methods: {
    getTreeData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i].children);
        }
      }
      return data;
    },
    handleSuccess(res) {
      if (res.code == 200) {
        this.fileList.push(res.result.id);
        this.ruleForm.fileList.push({
          name: res.result.file,
          url: res.result.ossUrl
        })
      } else {
        this.$message.warning(res.message);
      }
    },
    handleError(err) {
      this.$message.warning(JSON.parse(err.message).message);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      /* zd 20230913 修改 */
      // 高版本element会出现超过文件大小触发before-remove的问题(这时候的status是ready)，可以通过file.status的状态来区分
      if (file && file.status == 'success'){
        return this.$confirm(`确定移除 ${file.name}？`);
      }
    },
    /* zd 20230913 新增 */
    handleRemove(file, fileList) {
      let arr = fileList.filter((obj) => obj.uid != file.uid);
      this.fileList = [];
      arr.forEach((item) => {
        this.fileList.push(item.response.result.id);
      });
      this.ruleForm.fileList = fileList;
    },
    // 提交
    submitForm() {
      if (getStorage("basic")) {
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            let formdata = new FormData();
            for (let key in this.ruleForm) {
              if (key != "fileList") {
                formdata.append(key, this.ruleForm[key]);
              }
            }
            formdata.append("files", this.fileList.join(","));
            addAppeal(formdata).then((res) => {
              if (res.data.code == 200) {
                this.$message.success("您的诉求已收到，谢谢！");
                setTimeout(() => {
                  this.$router.push({
                    path: "/pcm/homePage",
                  });
                }, 1000);
              }
            });
          }
        });
      } else {
        this.$message.warning("请先登录!");
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleChange(val) {
      console.log(val);
    },
    /* zd 20230913 新增 */
    handelCheckFile(file){
      // const FileExt = file.name.replace(/.+\./, '')
      // if(this.accept.toLowerCase().indexOf(FileExt.toLowerCase()) === -1){
      //   this.$message.error('请上传后缀名为' + this.accept + '的文件！')
      //   return false
      // }
      // // 文件名校验
      // const reg = this.fileNameRule.rule
      // const name = file.name.split('.')
      // if(reg.test(name)){
      //   this.$message.warning(this.fileNameRule.error)
      //   return false
      // }
      // 文件大小
      let numberStr = ''
      let unitStr = ''
      this.fileSize.split('').forEach(item => {
        if(!isNaN(Number(item))){
          numberStr = numberStr + item + ''
        }else{
          unitStr = unitStr + item
          unitStr = unitStr.toLowerCase()
        }
      })
      let totalSize = file.size
      let errMessage = ''
      switch(unitStr){
        case 'm': case 'mb':
          totalSize = file.size / 1024 / 1024
          break
        case 'k': case 'kb':
          totalSize = file.size / 1024
          break
        case 'g': case 'bg':
          errMessage = '暂不接受gb级别的文件上传！'
          break
      }
      const isOverSize = totalSize > Number(numberStr)
      const sizeZero = totalSize === 0
      if(errMessage){
        this.$message.warning(errMessage)
        return false
      }else if(isOverSize){
        this.$message.warning('文件大小超过' + this.fileSize + '！')
        return false
      }else if(sizeZero){
        this.$message.warning('文件无内容！')
        return false
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.ExemptReview {
  ::v-deep {
    .el-cascader {
      width: 100%;
    }
  }
  .more {
    float: right;
    font-size: 15px;
    margin-right: 20px;
    cursor: pointer;
  }
  li {
    list-style: none;
  }
  .banner {
    width: 100%;
    height: 134px;
    margin: 10px auto 30px;
  }

  .bannerDiv {
    position: relative;
    .banner {
      width: 100%;
      height: 134px;
      margin: 10px auto 30px;
    }
    .bannerTitle {
      position: absolute;
      top: 35px;
      left: 50%;
      margin-left: -600px;
      color: white;
      letter-spacing: 5px;
      font-size: 34px;
      font-style: italic;
      width: 1200px;
    }
  }

  .dis_box {
    display: flex;
    justify-content: space-around;
    .dis_box_left {
      width: 68%;
      margin-right: 2%;
      border: 1px solid #eee;
      overflow: auto;

      //   background: red;
      .top {
        height: 60px;
        line-height: 60px;
        font-size: 24px;
        color: #333;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        padding-left: 20px;
        background: #f3f7fd;
        border-bottom: 1px solid #eee;
      }
      .form-title {
        line-height: 1;
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #000;
        letter-spacing: 0;
        font-weight: 500;
        margin-left: 24px;
        margin-bottom: 8px;
      }
      .mt24 {
        margin-top: 24px;
      }
      ::v-deep .el-input {
        width: 90%;
      }
      ::v-deep .el-textarea__inner {
        width: 95%;
      }
    }
    .dis_box_right {
      width: 30%;

      .dis_box_right_top {
        height: 60px;
        line-height: 60px;
        font-size: 24px;
        color: #333;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        padding-left: 20px;
        background: #f3f7fd;
        border-bottom: 1px solid #eee;
      }

      .state-no-data {
        border-bottom: 1px solid #eee;
        height: 104px;
        padding-left: 20px;
        border: 1px solid #eee;
        cursor: pointer;
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #333;
        letter-spacing: 0;
      }
      .state-no-data span {
        color: #1072e0;
        margin-right: 2px;
      }
      .process-box {
        margin-top: 39px;
        padding-bottom: 56px;
        border: 1px solid #eee;
        .process-title {
          height: 60px;
          line-height: 60px;
          font-family: PingFangSC-Medium;
          font-size: 24px;
          padding-left: 24px;
          color: #fff;
          font-weight: 500;
          background: url("https://www.szsiq.com/fb-web-appeal-ent-pc/img/process-bg.d3ebdaba.png")
            no-repeat;
        }
        /deep/ .el-steps--vertical {
          padding-left: 20px;
        }
      }
    }
  }
  .qa-box {
    margin: 25px auto;
    border: 1px solid #eee;

    .qa-box_dis {
      width: 100%;
      display: flex;
      justify-content: space-between;

      position: relative;
      /deep/.el-tabs__header {
        background: #f3f7fd;
      }
      ::v-deep .el-tabs__item {
        padding: 0 20px;
        height: 40px;
        box-sizing: border-box;
        line-height: 40px;
        display: inline-block;
        list-style: none;
        font-size: 18px;
        font-weight: 500;
        color: #303133;
        position: relative;
      }

      /deep/.el-tabs {
        width: 100%;
      }
      /deep/.wenti_box {
        width: 100%;
      }
      /deep/.el-tabs__nav-scroll {
        padding-top: 10px;
      }
      /deep/.el-tabs__nav-wrap::after {
        display: none;
      }

      .look {
        margin-top: 8px;
        position: absolute;
        top: -6px;
        right: 0px;
        .see-more {
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #1072e0;
          letter-spacing: 0;
          margin-right: 20px;
          margin-top: 10px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
